import { includedIn } from '@gcc/nodash';
import { flow, filter, curry } from 'lodash/fp';

import { getAttributeValue } from '../../helpers/getAttributeValue';

export default curry((purchaseOptions, designId, allItems) => flow(
  filter({ designId }),
  filter(flow(
    getAttributeValue('purchaseOption'),
    includedIn(purchaseOptions),
  )),
)(allItems));
